export const MEMBERSHIP_STATUS_STYLES = {
    active:    { color: "success",   icon: "mdi-check-circle",  label: "Ativo" },
    suspended: { color: "warning",   icon: "mdi-pause-circle",  label: "Suspenso" },
    canceled:  { color: "danger",    icon: "mdi-close-circle",  label: "Cancelado" },
    expired:   { color: "secondary", icon: "mdi-clock-alert",   label: "Expirado" }
};

export const MEMBERSHIP_DURATION_LABELS = {
    monthly: (d) => d > 1 ? `${d} meses` : "1 mês",
    yearly:  (d) => d > 1 ? `${d} anos`  : "1 ano",
    days:    (d) => `${d} dias`,
    classes: (d) => `${d} aulas`
};

export const MEMBER_PROFILE_TABS = [
    { id: '1', label: 'Meus Dados', icon: 'mdi-account-outline' },
    { id: '2', label: 'Financeiro', icon: 'mdi-cash-multiple' },
    { id: 'attendance', label: 'Frequência', icon: 'mdi-calendar-check' },
    { id: '3', label: 'Matrículas', icon: 'mdi-school-outline' },
    { id: '4', label: 'Planos', icon: 'mdi-file-document-outline' },
    { id: '5', label: 'Testes', icon: 'mdi-flask-outline' },
    { id: '6', label: 'Avaliações', icon: 'mdi-clipboard-check-outline' },
];
